export default __webpack_public_path__ + "static/media/136.37bda965.png";